import React, { useState } from 'react';
import './BookingForm.css';
import useToast from '../../../components/toast/UseToast';
import { BACKEND_BASE_URL } from '../../../const';

const BookingForm: React.FC = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        address: '',
        postcode: '',
        miniDetail: false,
        fullDetail: false,
        superDetail: false,
        cutAndPolish: false,
        message: ''
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const { showToast, ToastComponent } = useToast();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
        const checked = type === 'checkbox' ? (e.target as HTMLInputElement).checked : undefined;

        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(BACKEND_BASE_URL + '/book-now', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Success:', result);
                setIsSubmitted(true);
            } else {
                console.error('Error:', response.statusText);
                showToast('Booking attempt failed. Please try again.');
            }
        } catch (e) {
            console.error('Error:', e);
            showToast('Unexpected error occurred during submission. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (isSubmitted) {
        return (
            <div className="success-box">
                <h2>Thank you!</h2>
                <p>Your booking was submitted successfully.</p>
            </div>
        );
    }

    return (
        <>
            <form onSubmit={handleSubmit} className="booking-form">
                <h2>Detail your car without leaving the convenience of your driveway.</h2>

                <div className="form-group">
                    <label htmlFor="name">
                        Name <span className="required">*</span>
                    </label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="phone">
                        Phone <span className="required">*</span>
                    </label>
                    <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="email">
                        Email <span className="required">*</span>
                    </label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="postcode">
                        Postcode <span className="required">*</span>
                    </label>
                    <input
                        type="text"
                        id="postcode"
                        name="postcode"
                        value={formData.postcode}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="address">Address</label>
                    <input
                        type="text"
                        id="address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="phone">Service Required</label>
                    <div className='checkbox-container'>
                        <div>
                            <input type='checkbox' onChange={handleChange} checked={formData.miniDetail} name='miniDetail' />
                        </div>
                        <div>
                            <span className="checkbox-text">Mini Detail</span>
                        </div>
                    </div>
                    <div className='checkbox-container'>
                        <div>
                            <input type='checkbox' onChange={handleChange} checked={formData.fullDetail} name='fullDetail' />
                        </div>
                        <div>
                            <span className="checkbox-text">Full Detail</span>
                        </div>
                    </div>
                    <div className='checkbox-container'>
                        <div>
                            <input type='checkbox' onChange={handleChange} checked={formData.superDetail} name='superDetail' />
                        </div>
                        <div>
                            <span className="checkbox-text">Super Detail</span>
                        </div>
                    </div>
                    <div className='checkbox-container'>
                        <div>
                            <input type='checkbox' onChange={handleChange} checked={formData.cutAndPolish} name='cutAndPolish' />
                        </div>
                        <div>
                            <span className="checkbox-text">Cut and Polish</span>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea onChange={handleChange} value={formData.message} name='message' />
                </div>

                <button type="submit" className="submit-button" disabled={loading}>
                    {loading ? '❯❯ Sending...' : '❯❯ Send'}
                </button>
            </form>
            <ToastComponent />
        </>
    );
};

export default BookingForm;
